var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "panel",
      class: {
        "sidebar-active-item":
          _vm.activeItem && _vm.activeItem.tid == _vm.item.tid,
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "item d-flex justify-content-start align-items-center",
          attrs: { href: _vm.UrlService.itemHref(_vm.item, _vm.shop) },
          on: {
            click: function ($event) {
              _vm.UiService.isMobileView && _vm.UiService.toggleSidebar(false)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "vignette d-flex justify-content-center align-items-center",
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.UrlService.imagePath(
                    _vm.item.product.ShopId,
                    _vm.item.product.imt
                  ),
                  alt: _vm.item.product.dn,
                },
                on: {
                  error: function ($event) {
                    $event.target.src = "dist/assets/no-img.png"
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-item-title" }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.truncate(_vm.item.product.dn)) + "\n\t\t"
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.displayableChilds.length
        ? _c(
            "a",
            {
              staticClass: "list-arrow collapsed cursor-pointer",
              attrs: {
                role: "button",
                "data-parent": `#item-${_vm.item.parent.tid}-sub`,
                "data-target": `#item-${_vm.item.tid}-sub`,
                "data-toggle": "collapse",
                "aria-expanded": "false",
                "aria-controls": "Sub",
              },
            },
            [_c("i", { staticClass: "icon-eatselfapp_three-points" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayableChilds.length
        ? _c(
            "ul",
            {
              staticClass: "collapse",
              attrs: { id: `item-${_vm.item.tid}-sub` },
            },
            _vm._l(_vm.displayableChilds, function (item, i) {
              return _c("sidebar-item", {
                key: i,
                attrs: { item: item, shop: _vm.shop },
              })
            }),
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }